import Form, {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useCallback, useRef, useState } from 'react';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { useAssetClass } from '../../contexts/assetClass';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { swrConfig } from '../../pages/Assets/AssetsEdit';
import { Asset } from '../../types/asset.types';
import { IForm } from '../../types/iForm';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { dxSelectBoxConfig } from '../tasks/TasksForm';

export interface ICustomerAssetsForm extends IForm {
  assignedAssets: Asset[];
  customerId: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export const CustomerAssetsForm = ({
  assignedAssets,
  customerId,
  onCancel,
  onSuccess,
}: ICustomerAssetsForm) => {
  const { translate } = useTranslation();
  const { loading } = useLoading();
  const { assetClass } = useAssetClass();
  const transFormName = 'CustomerAssets.Create';
  const formRef = useRef<Form>(null);
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);

  const { data: assets } = useSWR<Asset[]>(
    `${API_URL.ASSET_LIST_BY_CLASS}?classId=${assetClass}&activeOnly=true&visibleOnly=true`,
    fetcher,
    swrConfig,
  );

  const test = useCallback(async () => {
    await putApi({
      url: `${API_URL.ASSET_ASSIGN_TO_CUSTOMER}?assetId=${selectedAssetId}&customerId=${customerId}`,
      data: {},
      callAfterSuccess: () => {
        onSuccess();
      },
    });
  }, [selectedAssetId]);

  return (
    <form
      onSubmit={(e) => {
        if (e !== null) e.preventDefault();
        test();
      }}
    >
      <Form colCount={1} showValidationSummary={true} ref={formRef}>
        <GroupItem>
          <SimpleItem
            dataField={'assetId'}
            editorType={'dxSelectBox'}
            editorOptions={{
              ...dxSelectBoxConfig,
              valueExpr: 'id',
              displayExpr: 'name',
              dataSource:
                assignedAssets.length === 0
                  ? assets
                  : assets?.filter(
                      (asset) => !assignedAssets.some((assigned) => assigned.id === asset.id),
                    ),
              onValueChanged: (e: any) => setSelectedAssetId(e.value),
            }}
          >
            <Label text={translate!('Asset', transFormName)} />
            <RequiredRule message={translate!('Asset is required', transFormName)} />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={4}>
          <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
            <ButtonOptions
              width={'100%'}
              text={translate!('Close', '')}
              type={'normal'}
              useSubmitBehavior={false}
              onClick={onCancel}
            />
          </ButtonItem>
          <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
            <ButtonOptions
              width={'100%'}
              disabled={loading}
              text={translate!('Save', '')}
              type={'success'}
              useSubmitBehavior
            />
          </ButtonItem>
        </GroupItem>
        {prompt}
      </Form>
    </form>
  );
};
